var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white",attrs:{"id":"home"}},[_c('Header'),_c('News'),_c('Services'),_c('About'),_c('Maps')],1)}
var staticRenderFns = []

export { render, staticRenderFns }